export const action = (type, payload = {}) => ({ type, ...payload });



// WEBPACK FOOTER //
// ./src/reducers/common.js